import CustomTopicContent from "@Components/CustomTopicContent/CustomTopicContent"
import EmptyDiscussions from "@Components/CustomTopicContent/EmptyDiscussions"
import { baseColors } from "@Constants/baseStyles"
import { ForumContext } from "@Providers/ForumProvider"
import { ForumService } from "@Services/Knowledge/SavoirEtre/Forum.Service"
import React, { useEffect, useRef, useState } from "react"
import { useContext } from "react"
import { ActivityIndicator, FlatList, RefreshControl, TouchableOpacity, View } from "react-native"
import styles from "./styles"
import TopicContentHeader from "./TopicContentHeader"
import TopicFooter from "./TopicFooter"

const TopicContent = (props) => {
    const { route } = props
    const flatlistRef = useRef(null)
    const { message, setMessage, shouldUpdateForumTopic, setShouldUpdateForumTopic } = useContext(ForumContext)
    const { forumId, topicCategory } = route?.params
    const [createMessage, setCreateMessage] = useState(false)
    const [loading, setLoading] = useState(false)
    const [edition, setEdition] = useState(false)
    const [updateList, setUpdateList] = useState(false)
    const [forumContent, setForumContent] = useState(null)
    const [messageId, setMessageId] = useState(0)
    const [sending, setSending] = useState(false)
    const [openCreateMessageModal, setOpenCreateMessageModal] = useState(false)

    const toggleAnswerInput = () => {
        setOpenCreateMessageModal((prev) => !prev)
        // setMessage("")
    }
    const toggleEdition = (messageToEdit) => {
        toggleAnswerInput()
        setEdition(true)
        setMessage(messageToEdit?.content)
        setMessageId(messageToEdit?.id)
    }

    const handleFetchForumById = () => {
        setLoading(true)
        ForumService.getForumById(forumId)
            .then((res) => {
                setForumContent(res.data.data)
                setLoading(false)
            })
            .catch(() => {
                setLoading(false)
            })
    }

    useEffect(() => {
        handleFetchForumById()
    }, [forumId, updateList])

    const messages = forumContent?.answers ?? []

    function successfull() {
        setSending(false)
        setShouldUpdateForumTopic((prev) => !prev)
        setOpenCreateMessageModal(false)
        setMessage("")
        setUpdateList((prev) => !prev)
    }

    const failed = () => {
        successfull()
        setSending(false)
    }

    const renderItem = ({ item }) => (
        <CustomTopicContent
            isMessage
            topicCategory={topicCategory}
            toggleEdition={toggleEdition}
            item={item}
            setMessageId={setMessageId}
            successfull={successfull}
            failed={failed}
            sending={sending}
        />
    )

    if (loading) {
        return (
            <View style={styles.loading}>
                <ActivityIndicator color={baseColors.orange.primary} size={50} />
            </View>
        )
    }

    return (
        <View style={styles.container}>
            <FlatList
                ref={messages?.length > 0 ? flatlistRef : null}
                onContentSizeChange={() => flatlistRef?.current?.scrollToEnd()}
                onLayout={() => flatlistRef?.current?.scrollToEnd()}
                contentContainerStyle={styles.contentContainer}
                data={messages}
                ListHeaderComponent={
                    <TopicContentHeader forumId={forumId} setUpdateList={setUpdateList} forumContent={forumContent} />
                }
                ListEmptyComponent={<EmptyDiscussions />}
                renderItem={renderItem}
                keyExtractor={(item) => item.id.toString()}
                refreshControl={<RefreshControl refreshing={loading} onRefresh={handleFetchForumById} />}
            />

            <TopicFooter
                forumId={forumId}
                toggleAnswerInput={toggleAnswerInput}
                createMessage={createMessage}
                setUpdateList={setUpdateList}
                forumContent={forumContent}
                messageId={messageId}
                edition={edition}
                setEdition={setEdition}
                message={message}
                setMessage={setMessage}
                sending={sending}
                setSending={setSending}
                successfull={successfull}
                failed={failed}
                openCreateMessageModal={openCreateMessageModal}
            />
        </View>
    )
}

export default TopicContent
